import { Box, Button, Dialog, Typography, makeStyles, useTheme } from '@material-ui/core';
import { useBackdropStyles, CustomBackdrop } from '@terragotech/gen5-shared-components';

interface Props {
  showModal: boolean;
  handleAction: (value: 'save' | 'cancel' | 'discard') => void;
  message: string;
}

const UnSavedChanges = ({ showModal, handleAction, message }: Props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const backdropClasses = useBackdropStyles();
  return (
    <Dialog
      open={showModal}
      onClose={undefined}
      maxWidth="xl"
      PaperProps={{
        style: {
          minWidth: 524,
          height: 160,
          padding: '20px 21px 20px 23px',
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        },
      }}
      BackdropComponent={CustomBackdrop}
      BackdropProps={{ classes: { root: backdropClasses.backdrop } }}
    >
      <Typography className={classes.header}>Unsaved Changes</Typography>
      <Typography className={classes.label}>{message}</Typography>
      <Box className={classes.footerRow}>
        <Button
          variant="contained"
          onClick={() => handleAction('cancel')}
          className={classes.cancel}
          disableElevation
        >
          Cancel
        </Button>
        <Box className={classes.rightContent}>
          <Button
            variant="outlined"
            color="primary"
            disableElevation
            onClick={() => handleAction('save')}
            className={classes.saveButton}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            onClick={() => handleAction('discard')}
            className={classes.discardButton}
          >
            Leave & Discard
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => ({
  header: {
    fontSize: 18,
    color: theme.palette.text.primary,
    fontWeight: 600,
    paddingBottom: 12,
  },
  label: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.text.secondary,
    paddingBottom: 28,
  },
  footerRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  rightContent: {
    width: '45%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 6,
  },
  cancel: {
    fontSize: 13,
    color: theme.palette.text.primary,
    fontWeight: 500,
    borderRadius: 2,
    height: 32,
    backgroundColor: theme.palette.action.hover,
  },
  saveButton: {
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 2,
    height: 32,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.paper,
  },
  discardButton: {
    fontSize: 13,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    fontWeight: 500,
    borderRadius: 2,
    height: 32,
    backgroundColor: theme.palette.primary.main,
  },
}));

export default UnSavedChanges;
